<script lang="ts">
	import AddShipmentParent from '$lib/features/shipments/components/Add/AddShipmentParent.svelte';
	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';
	import { products_state } from '$lib/features/products/state/products_state';
	import { seller_state } from '$lib/features/profile/states/seller_state';
	import { Loc } from '$lib/tools/locale.svelte';
	import { onMount } from 'svelte';

	let add_modal_open = $state(false);

	function products_sub_fn() {
		return products_state.items_with_sub();
	}

	onMount(() => {
		const listener = (e: KeyboardEvent) => {
			if (e.key === 'Escape' && add_modal_open) add_modal_open = false;
		};
		window.addEventListener('keydown', listener);
		return () => window.removeEventListener('keydown', listener);
	});
</script>

{#if seller_state.value}
	<button
		onclick={() => (add_modal_open = true)}
		aria-label={Loc('add|shipment')}
		class="fixed bottom-[calc(4.5rem+env(safe-area-inset-bottom))] end-3 z-[95] flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground transition-transform active:scale-95 sm:end-[max(0.75rem,calc(50vw-336px-2.5rem))] lg:end-[max(0.75rem,calc(50vw-550px-2.5rem))]"
	>
		<LucideIcon name="Plus" size="22" class="rtl:rotate-180" />
	</button>

	{#if add_modal_open}
		<AddShipmentParent {products_sub_fn} mode="seller" seller={seller_state.value} bind:open={add_modal_open} />
	{/if}
{/if}
